import { createRoute } from "@tanstack/solid-router";
// FLAGS: la página entera se gatea por feature (org activa).
import { withFeatureGate } from "@/features/flags/feature-gate";
import { msg } from "@lingui/core/macro";
import { FileText } from "lucide-solid";
import { appRoute } from "./route";
import { useI18n } from "@/providers/i18n-provider";
import { PageContainer } from "@/components/ui/page-container";
import { PageHeader } from "@/components/ui/page-header";
import { FinanceInvoices } from "@/features/finance/components/finance-invoices";

function FinanceInvoicesPage() {
  const { t } = useI18n();
  return (
    <PageContainer maxWidth="4xl">
      <PageHeader title={t(msg`Invoices`)} backTo="/finance" icon={FileText} />
      <div class="mt-4">
        <FinanceInvoices />
      </div>
    </PageContainer>
  );
}

export const financeInvoicesRoute = createRoute({
  getParentRoute: () => appRoute,
  path: "/finance/invoices",
  component: withFeatureGate("billing.core", FinanceInvoicesPage),
});
